var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ali-player',{ref:"player",attrs:{"source":_vm.视频url}}),_vm._v(" "),_c('button',{on:{"click":_vm.play}},[_vm._v("播放")]),_vm._v(" "),_c('button',{on:{"click":_vm.pause}},[_vm._v("暂停")]),_vm._v(" "),_c('button',{on:{"click":_vm.replay}},[_vm._v("重播")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-55ed997e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/view/show.vue
// module id = null
// module chunks = 